
          
function myFunctionFooterMenu(x) {
  if (x.matches) { // If media query matches
    $(".footer--blocks__heading").click(function(){
      let $this = $(this)
      $(this).parent().toggleClass("activated")
      $(this).next().toggle("fast")
    })
  }
}
var x = window.matchMedia("(max-width: 1005px)")
myFunctionFooterMenu(x) // Call listener function at run time
x.addListener(myFunctionFooterMenu) // Attach listener function on state changes

$(".header__menu-button").click(function(){
  $(".nav-drawer").slideToggle("fast");
  if($(".site-overlay").attr("data-animation-state") == 'open'){
    $(".site-overlay").attr("data-animation-state","closed");
  }else{
    $(".site-overlay").attr("data-animation-state","open");
  }
  $(".section-header").toggleClass("z-801");
})
$(".site-overlay").click(function(){
  $(".nav-drawer").slideUp("fast");
  $(".site-overlay").attr("data-animation-state","closed");
  $(".section-header").removeClass("z-801");
})